// extracted by mini-css-extract-plugin
module.exports = {"placeHolderContainer":"styles-moduleplaceHolderContainer-3LD7M"};